'use client';
import { useBrand } from '@coverright/shared/brand';

export interface ContactPhone {
  display: string;
  tel: string; // E.164, e.g. +18889697667
  // true when this number is the visitor's brand phone rather than the fallback
  // default — callers that also have their own number (e.g. an assigned agent's
  // phone) should let the brand number win.
  overridden: boolean;
}

type RulePhone = Omit<ContactPhone, 'overridden'>;

const DEFAULT_PHONE: RulePhone = { display: '+1 (888) 969-7667', tel: '+18889697667' };

// Phone to show the current visitor: the brand's phone (see @coverright/shared/brand,
// resolved by initBrand() before the first render), otherwise each app's `fallback`.
export function useContactPhone(fallback: RulePhone = DEFAULT_PHONE): ContactPhone {
  const phone = useBrand()?.phone;
  if (!phone) {
    return { ...fallback, overridden: false };
  }
  return {
    display: `+1 (${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`,
    tel: `+1${phone}`,
    overridden: true,
  };
}
